import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "../../../environments/environment";
import {forkJoin, lastValueFrom} from "rxjs";
import {DecimalPipe} from "@angular/common";
import {ReplaceStringPipe} from "../../shared/pipes/replace-string.pipe";
import {LPService} from "../../shared/services/lp.service";
import {AppConfigService} from "../../shared/services/config/app-config.service";

@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    providers: [DecimalPipe, ReplaceStringPipe],
    encapsulation: ViewEncapsulation.None
})
export class TermsConditionsComponent implements OnInit {
    loanPurpose: string | null = '';
    product: string | null = '';
    cardName: string = '';
    cardDetail: any = null;
    merchantId: string | null = null;
    termsConditionsHtml: string;
    showLoader: boolean = true;
    appConfig = AppConfigService.config;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private decimalPipe: DecimalPipe,
                private replaceStringPipe: ReplaceStringPipe,
                private lpService: LPService) {
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.merchantId = params['merchantId'];
        });

        this.activatedRoute.paramMap.subscribe(params => {
            this.loanPurpose = params.get('loanPurpose');
            this.product = this.loanPurpose?.startsWith("BCC") ? "BUSINESS_CREDIT_CARD" : "CREDIT_CARD";
            this.cardName = params.get('cardName') || '';
            if (this.loanPurpose && this.cardName) {
                this.cardDetail = this.appConfig[this.loanPurpose].offerVariationDetails[this.cardName];

                if (!this.cardDetail) {
                    this.router.navigate(['/']);
                } else {
                    this.cardDetail.imageUrl = `${environment.s3Url}images/${environment.institutionCode}/${this.merchantId}_${this.cardName}.png` || this.cardDetail.imageUrl;
                    this.cardDetail.tcUrl = `${environment.s3Url}html/${environment.institutionCode}/${this.cardName.toLowerCase()}_tc.html`;
                }
            } else {
                this.router.navigate(['/']);
            }
        });

        this.getRatesDetails()

    }

    getRatesDetails() {

        const ratesLookupAPIs = [];

        ratesLookupAPIs.push(this.lpService.getRatesDetails(this.loanPurpose, this.cardName, this.product));

        ratesLookupAPIs.push(this.lpService.getRatesLookup());
        // ratesLookupAPIs.push(this.lpService.getRatesRanges(this.loanPurpose, this.product, this.cardName));

        // Make the HTTP request with the authorization header
        forkJoin(ratesLookupAPIs).subscribe({
            next: async (response: any) => {
                const ccRatesLookup = response[1].offerVariationDetails;
                // this.subProductRatesLookup = response[0].offerRatesLookupVOList;

                let subProductRatesLookup = ccRatesLookup.find((lookup: {
                    offerVariationDetailsId: number;
                }) => Number(lookup.offerVariationDetailsId) === Number(response[0].offerRatesLookupVOList[0].offerVariationDetailsId));
                subProductRatesLookup = {...response[0].offerRatesLookupVOList[0], ...subProductRatesLookup}

                subProductRatesLookup = {
                    ...subProductRatesLookup,
                    ...response[0].offerRatesLookupVOList.reduce((rateLookup: any, obj: any) => {
                        if (Number(obj.purchaseAPR) < rateLookup.minPurchaseAPR) rateLookup.minPurchaseAPR = Number(obj.purchaseAPR);
                        if (Number(obj.purchaseAPR) > rateLookup.maxPurchaseAPR) rateLookup.maxPurchaseAPR = Number(obj.purchaseAPR);
                        if (Number(obj.cashAdvanceAPR) < rateLookup.minCashAdvanceAPR) rateLookup.minCashAdvanceAPR = Number(obj.cashAdvanceAPR);
                        if (Number(obj.cashAdvanceAPR) > rateLookup.maxCashAdvanceAPR) rateLookup.maxCashAdvanceAPR = Number(obj.cashAdvanceAPR);
                        if (Number(obj.balanceTransferAPR) < rateLookup.minBalanceTransferAPR) rateLookup.minBalanceTransferAPR = Number(obj.balanceTransferAPR);
                        if (Number(obj.balanceTransferAPR) > rateLookup.maxBalanceTransferAPR) rateLookup.maxBalanceTransferAPR = Number(obj.balanceTransferAPR);

                        return rateLookup;
                    }, {
                        minBalanceTransferAPR: 999,
                        maxBalanceTransferAPR: 0,
                        minPurchaseAPR: 999,
                        maxPurchaseAPR: 0,
                        minCashAdvanceAPR: 999,
                        maxCashAdvanceAPR: 0
                    })
                }

                // Show exact APR when min and max same otherwise show range
                subProductRatesLookup.purchaseAPRDisplay = subProductRatesLookup.minPurchaseAPR === subProductRatesLookup.maxPurchaseAPR ? `${subProductRatesLookup.maxPurchaseAPR}%` : `${subProductRatesLookup.minPurchaseAPR}% to ${subProductRatesLookup.maxPurchaseAPR}%`;
                subProductRatesLookup.marginPurchaseAPRDisplay = subProductRatesLookup.minPurchaseAPR === subProductRatesLookup.maxPurchaseAPR ? `${this.decimalPipe.transform(Number(subProductRatesLookup.maxPurchaseAPR) - 7,"0.0-2")}%` : `${this.decimalPipe.transform(Number(subProductRatesLookup.minPurchaseAPR) - 7,"0.0-2")}% to ${this.decimalPipe.transform(Number(subProductRatesLookup.maxPurchaseAPR) - 7,"0.0-2")}%`;
                subProductRatesLookup.cashAdvanceAPRDisplay = subProductRatesLookup.minCashAdvanceAPR === subProductRatesLookup.maxCashAdvanceAPR ? `${subProductRatesLookup.maxCashAdvanceAPR}%` : `${subProductRatesLookup.minCashAdvanceAPR}% to ${subProductRatesLookup.maxCashAdvanceAPR}%`
                subProductRatesLookup.marginCashAdvanceAPRDisplay = subProductRatesLookup.minCashAdvanceAPR === subProductRatesLookup.maxCashAdvanceAPR ? `${this.decimalPipe.transform(Number(subProductRatesLookup.maxCashAdvanceAPR) - 7,"0.0-2")}%` : `${this.decimalPipe.transform(Number(subProductRatesLookup.minCashAdvanceAPR) - 7,"0.0-2")}% to ${this.decimalPipe.transform(Number(subProductRatesLookup.maxCashAdvanceAPR) - 7,"0.0-2")}%`;
                subProductRatesLookup.balanceTransferAPRDisplay = subProductRatesLookup.minBalanceTransferAPR === subProductRatesLookup.maxBalanceTransferAPR ? `${subProductRatesLookup.maxBalanceTransferAPR}%` : `${subProductRatesLookup.minBalanceTransferAPR}% to ${subProductRatesLookup.maxBalanceTransferAPR}%`
                console.log(subProductRatesLookup);
                const tcHtml = await lastValueFrom(this.lpService.getTermsConditions(`${this.cardName.toLowerCase()}_tc.html`));
                this.populateResponse(tcHtml, subProductRatesLookup);
                // if (response && response.offerRatesLookupVOList && response.offerRatesLookupVOList.length > 0) {
                //     //   this.setCreditCards(response);
                //     console.log(response)
                // }
            },
            error: (error) => {
                console.error('Error:', error);
            }
        });
    }

    populateResponse(content: any, subProductLookup: any) {

        // let postFix = `-${this.keyIdentifier.loanPurposeConfig.id.toLowerCase()}`;
        // postFix += this.subProductName ? "-" + this.subProductName.toLowerCase() : "";
        const offerPurchaseAPR = this.decimalPipe.transform((subProductLookup?.purchaseAPR || 0).toString().replace("%", ""), "0.0-2") || 0;
        const penaltyAPRDesc = this.decimalPipe.transform(subProductLookup?.penaltyAPRDesc ? subProductLookup?.penaltyAPRDesc.replace("%", "") : 0, "0.0-2") || 0;
        const variableRateIndex = subProductLookup?.purchaseRateType === "variable" ? subProductLookup?.lender.purchaseVariableBaseRate : subProductLookup?.lender.purchaseFixedBaseRate;
        const today = new Date();
        const placeholders = {
            today: `${today.toLocaleString('default', { month: 'long' })} ${today.getDate()}, ${today.getFullYear()}`,
            institutionName: environment.institutionCode,
            subProductNameTitle: this.cardDetail.title,
            offerPurchaseAPR,
            balanceTransferAPR: this.decimalPipe.transform((subProductLookup?.balanceTransferAPR || "").replace("%", "") || 0, "0.0-2"),
            balanceTransferAPRDisplay: subProductLookup.balanceTransferAPRDisplay,
            balanceTransferIntroAPR: this.decimalPipe.transform(subProductLookup?.balanceTransferIntroAPR ? subProductLookup?.balanceTransferIntroAPR.replace("%", "") : 0, "0.0-2"),
            balanceTransferIntroAPRDaily: this.decimalPipe.transform((subProductLookup?.balanceTransferIntroAPR ? Number(subProductLookup?.balanceTransferIntroAPR.replace("%", "")) : 0) / 365, "0.0-4"),
            purchaseIntroAPR: this.decimalPipe.transform((subProductLookup?.purchaseIntroAPR || "").replace("%", ""), "0.0-2") || 0,
            minPurchaseAPR: subProductLookup.minPurchaseAPR,
            maxPurchaseAPR: subProductLookup.maxPurchaseAPR,
            purchaseAPRDisplay: subProductLookup.purchaseAPRDisplay,
            dailyPurchaseIntroAPR: this.decimalPipe.transform((+(subProductLookup?.purchaseIntroAPR || "").replace("%", "") || 0) / 365, "0.0-2"),
            purchaseIntroPeriod: subProductLookup?.purchaseIntroPeriod,
            cashAdvanceAPR: this.decimalPipe.transform(subProductLookup?.cashAdvanceAPR ? subProductLookup?.cashAdvanceAPR.replace("%", "") : 0, "0.0-2"),
            cashAdvanceAPRDisplay: subProductLookup.cashAdvanceAPRDisplay,
            penaltyAPRDesc,
            subProductName: this.cardName || "",
            headerLogo: environment.s3Url + environment.institutionCode + "/logo.png",
            logo: environment.s3Url + environment.institutionCode + "/loading.png",
            balanceTransferIntroPeriod: subProductLookup?.balanceTransferIntroPeriod,
            purchaseRate: subProductLookup?.purchaseRateType === "variable" ? subProductLookup?.lender.purchaseVariableBaseRate : subProductLookup?.lender.purchaseFixedBaseRate,
            replacePurchaseRate: subProductLookup?.purchaseAPR?.replace("%", ""),
            dividePurchaseAPR: this.decimalPipe.transform(subProductLookup?.purchaseAPR ? (+subProductLookup?.purchaseAPR.replace("%", "") / 365) : 0, "0.0-4"),
            purchaseAPR: this.decimalPipe.transform(subProductLookup?.purchaseAPR ? subProductLookup?.purchaseAPR.replace("%", "") : 0, "0.0-2"),
            dividePenaltyAPRDesc: this.decimalPipe.transform(subProductLookup?.penaltyAPRDesc ? (+subProductLookup?.penaltyAPRDesc.replace("%", "") / 365) : 0, "0.0-2"),
            variableRateIndex,
            variableRateMargin: +offerPurchaseAPR - (+variableRateIndex),
            dailyPeriodicRate: this.decimalPipe.transform(+offerPurchaseAPR / 365, "0.0-4"),
            fixedPeriodicRate: this.decimalPipe.transform(+penaltyAPRDesc / 365, "0.0-4"),
            returnedPaymentFeeDesc: subProductLookup.returnedPaymentFeeDesc,
            purchaseRateType: subProductLookup.purchaseRateType,
            foreignTransactionDesc: subProductLookup.foreignTransactionDesc,
            latePaymentFeeDesc: subProductLookup.latePaymentFeeDesc,
            minBalanceTransferAPR: subProductLookup.minBalanceTransferAPR,
            maxBalanceTransferAPR: subProductLookup.maxBalanceTransferAPR,
            minPurchaseApr: subProductLookup.minPurchaseApr,
            maxPurchaseApr: subProductLookup.maxPurchaseApr,
            minCashAdvanceAPR: subProductLookup.minCashAdvanceAPR,
            maxCashAdvanceAPR: subProductLookup.maxCashAdvanceAPR,
            marginPurchaseAPRDisplay: subProductLookup.marginPurchaseAPRDisplay,
            marginCashAdvanceAPRDisplay: subProductLookup.marginCashAdvanceAPRDisplay
        };


        if (content) {
            this.termsConditionsHtml = this.replaceStringPipe.transform(content, placeholders);
        }
        this.showLoader = false;
        setTimeout(() => {
            document.querySelectorAll('#cards-terms-conditions table').forEach(item => item.classList.add('table', 'table-bordered'));
        }, 50)


    }

}
